import React from 'react'

import styles from './panel.module.css'

import logo from '../images/logo.png'

const Panel = () => (
  <div className={styles.wrapper}>
    <div className={styles.articleBox}>
      <div className={styles.container}>
        <div className={styles.topBar}>
          <img src={logo} alt="Unslant" className={styles.logo} />
          <div className={styles.closeButton}>×</div>
        </div>
        <div>
          <div
            className={styles.articleImage}
            style={{
              backgroundImage:
                'url(https://fivethirtyeight.com/wp-content/uploads/2019/12/PollingAveragesStory_4x3.png?w=1150)',
            }}
          />
          <div className={styles.articleExcerpt}>
            <p className={styles.articleQuote}>
              What Makes Our New 2020 Democratic Primary Polling Averages
              Different
            </p>
            <div className={styles.articleSource}>
              <img
                src="https://fivethirtyeight.com/wp-content/themes/espn-fivethirtyeight/assets/images/favicon.ico?v=1.0.22"
                className={styles.favicon}
                alt=""
              />
              FiveThirtyEight · Center
            </div>
          </div>
        </div>
      </div>
      {/* eslint-disable-next-line jsx-a11y/anchor-is-valid */}
      <a href="#">
        <div className={styles.link}>Click to read</div>
      </a>
    </div>
  </div>
)

export default Panel
